var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"license":_vm.license}})
}
var staticRenderFns = []

export { render, staticRenderFns }